import React, { useEffect, useRef, useState } from "react";
import { toast } from "react-hot-toast";
import { toastFail } from "../../../config";

type AppDocumentsUploadButtonProps = {
  label: string;
  onFileSelect?: (file: File) => void;
  disabled?: boolean;
}

const MAX_FILE_UPLOAD_SIZE = 10485760;

const ACCEPTABLE_FILES =
  "application/pdf, " +
  "application/msword, " +
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document, ";

export const AppDocumentsUploadButton = ({ label, onFileSelect, disabled }: AppDocumentsUploadButtonProps) => {
    

    const [uploadFile, setUploadFile] = useState<string>("")
    const fileInputRef = useRef<HTMLInputElement>(null);

    // useEffect(()=> {
    //     setUploadFile("");
    // }, [])

    const handleOpenFilePicker = () => {
        // alert("Ref: " + fileInputRef?.current);

        if (fileInputRef?.current) {
          const inputButton = fileInputRef.current;
          setUploadFile("");
          inputButton.click();
        }
      };

    

    const handleFileChange = (event: any) => {
        for (let i = 0; i < event.target.files.length; i++) {
            if (event.target.files[i].size > MAX_FILE_UPLOAD_SIZE) {
                toast("File is too big! Please keep it under 10MB", toastFail);
                return;
            }
        }

        const file = event.target.files?.[0];
            if (file && onFileSelect) {
                setUploadFile(file.name);
                onFileSelect(file);
            }
            if (fileInputRef.current) {
                fileInputRef.current.value = "";
        }
    };

    return (
        <div
            className="app-documents-upload-button"
        >
           
            {uploadFile}
            <button
                type="button"
                className="button-cancel"
                onClick={handleOpenFilePicker}
                disabled={disabled}
            >
                {uploadFile ? "Change File" : label}
            </button>
            <input
                type="file"
                ref={fileInputRef}
                // value={uploadFile}
                onChange={handleFileChange}
                accept={ACCEPTABLE_FILES}
                disabled={disabled}
                multiple={false}
                aria-label={label}
                style={{ display: "none" }}
            />
        </div>
    );
};

